import Component from "../abstracts/Component";
export default class ShowMoreComponent extends Component {
  get SELECTORS() {
    return {
      main: '.trim-text',
      container: '.js-cutter',
      selector: '.button-tertiary'
    }
  }

  get CLASSES() {
    return {
      active: 'show-more'
    }
  }


  bindEvent(el) {

    var btn = el.querySelector(this.SELECTORS.selector);
    btn.addEventListener("click", () => {
      var text = el.querySelector(this.SELECTORS.main);
      text.classList.toggle(this.CLASSES.active);
    });

  }

  render() {

    var elements = document.querySelectorAll(this.SELECTORS.container);

    if (elements.length > 0) {
      elements.forEach(element => {
        this.bindEvent(element);
      });
    }
  }
}
